<nb-card>
    <ng-content></ng-content>
</nb-card>
